export interface ExploreCardDocument {
  images?: string[] | null;
  preview_images?: string[] | null;
  static_map_url?: string | null;
  static_map?: string | null;
}

/**
 * The photo an Explore card shows. `images` are the original uploads (often a
 * multi-MB camera JPEG), so prefer the resized `preview_images` the hikes index
 * carries alongside them. Documents indexed before that field existed, and the
 * community feed, only have `images`; with no photo at all the card falls back
 * to the static map.
 */
export const exploreCardImage = (document: ExploreCardDocument | null | undefined): string | undefined => {
  if (!document) return undefined;

  const preview = document.preview_images?.[0];
  if (preview) return preview;

  const original = document.images?.[0];
  if (original) return original;

  return document.static_map_url || document.static_map || undefined;
};
